import script from "./AsesoriaImpositivaPrivadoView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsesoriaImpositivaPrivadoView.vue?vue&type=script&setup=true&lang=js"

import "./AsesoriaImpositivaPrivadoView.vue?vue&type=style&index=0&id=56ae6748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ae6748"]])

export default __exports__